import script from "./CreatorPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CreatorPage.vue?vue&type=script&setup=true&lang=js"

import "./CreatorPage.vue?vue&type=style&index=0&id=df0a9a40&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-df0a9a40"]])

export default __exports__